import store, { subscribe } from 'shared/store'
import { actionNames } from 'shared/store/ducks/userSession'
import { destroyModalAction } from 'shared/store/ducks/events'
import { LOGIN_MODAL_ID } from 'views/consts'

export default () => {
  subscribe.after(actionNames.setUserSession, ({ userSession }) => {
    const { isLoggedIn } = userSession
    if (isLoggedIn) {
      store.dispatch(destroyModalAction(LOGIN_MODAL_ID))
    }
  })
}
